import { BlockBrandsModal } from './block-brands-modal';

export { BlockBrandsModal };
